// extracted by mini-css-extract-plugin
export default {"button":"PrimaryButton_button__75GYS","container":"PrimaryButton_container__i1llA"};